// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__XWcMK","noListStyle":"List_noListStyle__fW_Wp","withIcon":"List_withIcon__L8ulF","isIconTop":"List_isIconTop__VH4LX","number":"List_number__an3NA"};